import { chunk } from 'lodash';

import { Box } from '@hivebrite/design-system/Box';

import { useStore } from 'hb-react/frontoffice/components/BlocksRenderer/store';
import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

const dataSelector = (state) => state.data;

const ItemsContent = ({
  blockId,
  clearFilters,
  columnsInMobile,
  emptyState: EmptyState,
  fetchedData,
  hasNoResult,
  isLoading,
  itemLoader: ItemLoader,
  itemRenderer: ItemRenderer,
  itemsByRow,
  loaderLines,
  noResultsMessage,
  rowGap,
}) => {
  const data = useStore(dataSelector);

  if (isLoading) {
    return (
      <RowsWrapper
        rowGap={rowGap}
        itemsRows={chunk(
          Array.from(new Array(itemsByRow * loaderLines)),
          itemsByRow,
        )}
        itemsByRow={itemsByRow}
        isLoading={isLoading}
        columnsInMobile={columnsInMobile}
      >
        {() => <ItemLoader />}
      </RowsWrapper>
    );
  }

  if (hasNoResult) {
    return (
      <Wrapper
        isLoading={isLoading}
        rowGap={rowGap}
        columnsInMobile={columnsInMobile}
      >
        <Row>
          <Col width={itemsByRow > 1 ? 1 / 2 : 1}>
            <Box mb={10}>
              <EmptyState
                clearFilters={clearFilters}
                noResultsMessage={noResultsMessage}
              />
            </Box>
          </Col>
        </Row>
      </Wrapper>
    );
  }

  const items = fetchedData?.pages.reduce(
    (acc, value) => [...acc, ...value.items],
    [],
  );

  return (
    <RowsWrapper
      itemsRows={chunk(items, itemsByRow)}
      itemsByRow={itemsByRow}
      isLoading={isLoading}
      rowGap={rowGap}
      columnsInMobile={columnsInMobile}
    >
      {({ indexRow, indexCol, item }) => (
        <ItemRenderer
          blockId={blockId}
          data={data}
          index={indexRow * itemsByRow + indexCol}
          item={item}
          key={item.id}
        />
      )}
    </RowsWrapper>
  );
};

const RowsWrapper = ({
  children,
  itemsRows,
  itemsByRow,
  isLoading,
  rowGap,
  columnsInMobile,
}) => (
  <Wrapper
    isLoading={isLoading}
    rowGap={rowGap}
    columnsInMobile={columnsInMobile}
  >
    {itemsRows.map((row, indexRow) => (
      <Row key={indexRow} data-testid={`items-row-${indexRow}`}>
        {row.map((item, indexCol) => (
          <Col
            data-testid="item"
            key={indexCol}
            width={({ numCols }) => numCols / itemsByRow / numCols}
          >
            {children({ indexRow, indexCol, item })}
          </Col>
        ))}
      </Row>
    ))}
  </Wrapper>
);

const Wrapper = ({ children, isLoading, rowGap, columnsInMobile }) => (
  <Box
    height="auto"
    display="block"
    pb={6}
    mt={rowGap}
    data-testid={`${isLoading ? 'items-loading' : 'items'}`}
  >
    <Grid mx={0} rowGap={rowGap} columnsInMobile={columnsInMobile}>
      {children}
    </Grid>
  </Box>
);

export default ItemsContent;
